var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DPlayer',{attrs:{"url":_vm.$route.query.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }